import { ToastProps } from "../ToastManager";

export type FeatureFlagOverrideToastProps = {
  overrides: Record<string, boolean>
} & ToastProps

export function FeatureFlagOverrideToast({ overrides, dismiss }: FeatureFlagOverrideToastProps) {
  const entries = Object.entries(overrides);

  return (
    <div className="notification is-warning" onClick={dismiss} style={{ cursor: "pointer" }}>
      <p style={{ fontWeight: 600, marginBottom: "0.5rem" }}>Feature flag overrides active</p>
      <ul style={{ fontFamily: "monospace", fontSize: "0.85rem", margin: 0, paddingLeft: "1rem" }}>
        {entries.map(([flag, value]) => (
          <li key={flag}>{flag}: {String(value)}</li>
        ))}
      </ul>
    </div>
  );
}
